import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useRecoilState } from 'recoil';
import loginImage from '../assets/icons/login_img.png'
import loginStateAtom from '../atoms/loginStateAtom';
import { app_version, url } from '../utils/config';
import myInfoAtom from '../atoms/myInfoAtom';
import { btnOne, inputStyle } from '../utils/style';

function Login(props) {
    const [ loggedIn, setLoggedIn ] = useRecoilState(loginStateAtom);
    const [ myInfo, setMyInfo ] = useRecoilState(myInfoAtom)
    const [ loginScreen, setLoginScreen ] = useState(true);
    const [ email, setEmail ] = useState("");
    const [ otp, setOtp ] = useState("");
    const [ uid, setUid ] = useState("");
    const navigate = useNavigate();


    async function getOtp() {
        if(email && email.match('@') && email.match('.')) {
            const reqUrl = url + '/get_otp/login';
            axios.post(reqUrl, {email})
            .then(res => {
                setUid(res.data.uid);
                toast.success('Auth Code generated!', { autoClose: 3000 })
                setTimeout(() => { 
                    setLoginScreen(false);
                } ,200)
            })
            .catch(err => toast.error(err.response.data.message, { autoClose: 3000 }))
        } else {
            toast.error('Please provide a valid Email!', { autoClose: 3000 })
        }
    }

    async function phoneLogin() {
        const reqUrl = url + '/login/2FA';  
        axios.post(reqUrl, { email, otp, uid})
        .then(res => {
            toast.success('Logged-In Successfully!', { autoClose: 3000 })
            window.localStorage.setItem('token', res.data.token);
            setMyInfo(res.data.info);
            setLoggedIn(true)
            navigate('/')
            })
        .catch(err => toast.error(err.response.data.message, { autoClose: 3000 }))
    } 

    function handleGetOtp(e) {
        if(e.key === 'Enter') {
            getOtp()
        }
    }

    function handleLogin(e) {
        if(e.key === 'Enter') {
            phoneLogin()
        }
    }


    return(
        <div className='h-screen w-screen bg-customTwo flex'>
            <div className='basis-1/2 flex items-center justify-center w-full'>
                <div>
                    <div className='text-center font-semibold text-xl'>Hello Manager!</div>
                    <div className='text-center text-sm mb-4'>Login to continue managing your Roll & Charge.</div>
                    <div>
                        <img src={loginImage} />
                    </div>
                </div>
            </div>
            <div className='basis-1/2 flex items-center justify-center w-full bg-white rounded-l-lg'>
                {
                    loginScreen ?
                    <div>
                        <div className='text-center font-semibold text-xl'>Login To Roll & Charge</div>
                        <div className='text-center text-sm mb-8'>Please enter your email for the verification code.</div>
                        <div>
                            <input 
                                className={inputStyle} 
                                placeholder='Please enter your email address'
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                onKeyDown={e => handleGetOtp(e)}
                            />
                        </div>
                        <div className='py-2'>
                            <button className={btnOne} onClick={() => getOtp()}>Send Verification Code</button>
                        </div>
                        <div className="text-right text-sm text-gray-300 p-2 fixed bottom-4 right-4">{app_version}</div>
                    </div>
                    :
                    <div>
                        <div className='text-center font-semibold text-xl'>Check Your Email</div>
                        <div className='text-center text-sm mb-8'>Please enter your verification code to continue.</div>
                        <div>
                            <input 
                                className={inputStyle} 
                                placeholder='Please enter your verification code'
                                value={otp}
                                onChange={e => setOtp(e.target.value)}
                                onKeyDown={e => handleLogin(e)}
                            />
                        </div>
                        <div className='py-2'>
                            <button className={btnOne} onClick={() => phoneLogin()}>Submit</button>
                        </div>
                        <div className='text-customOne text-xs text-center'>Didn't receive the code? <span className='font-semibold cursor-pointer' onClick={() => getOtp()}>Click to resend</span></div>
                        <div className="text-right text-sm text-gray-300 p-2">Version 1.0</div>
                    </div>
                }
            </div>
        </div>
        // <div className='flex justify-end h-screen py-8 pr-8' style={{backgroundImage: `url(${loginImage})`}}>
        //     <div className='inline-flex flex-col p-12 h-full bg-purple-400 bg-opacity-50'>
        //         {
        //             loginScreen ? 
        //             <div>
        //                 <div className='text-white text-3xl mb-4'>Enter Email</div>
        //                 <input 
        //                     className='h-12 w-96 px-2 outline-none rounded-md' 
        //                     type='email' 
        //                     value={email} 
        //                     placeholder='Enter Email'
        //                     onChange={e => setEmail(e.target.value)} 
        //                 />
        //                 <div className='flex justify-center'>
        //                     <div className='px-6 py-2 border border-black rounded-md mt-6 font-semibold text-lg cursor-pointer hover:bg-purple-700 hover:bg-opacity-50' onClick={() => getOtp()}>Authenticate</div>
        //                 </div>
        //             </div> : 
        //             <div>
        //                 <div className='text-white text-3xl mb-4'>Auth Code</div>
        //                 <input 
        //                     className='h-12 w-96 px-2 outline-none rounded-md' 
        //                     value={otp} 
        //                     type='number'
        //                     maxLength={6}
        //                     placeholder='Auth Code'
        //                     onChange={e => setOtp(e.target.value)} 
        //                 />
        //                 <div className='flex justify-center'>
        //                     <div className='px-6 py-2 border border-black rounded-md mt-6 font-semibold text-lg cursor-pointer hover:bg-purple-700 hover:bg-opacity-50' onClick={() => phoneLogin()}>Submit</div>
        //                 </div>
        //             </div>
        //         }
        //     </div>
        // </div>
    )

}

export default Login;